import $ from 'jquery'

$('.js-training-center').on('click', function () {
  $('.js-connection-btn').attr('href', $(this).attr('data-connection-link'))

  var ypareoBtn = $('.js-ypareo-btn')
  if ( $(this).attr('data-ypareo-link') ) {
    ypareoBtn.attr('href', $(this).attr('data-ypareo-link'))
    ypareoBtn.css('display', 'inline-flex')
  }
  else {
    ypareoBtn.css('display', 'none')
  }

  var registrationBtn = $('.js-registration-btn')
  var registrationForm = $('.js-registration-form')
  if ( $(this).attr('data-use-link') ) {
    registrationBtn.attr('href', $(this).attr('data-registration-link'))
    registrationBtn.css('display', 'inline-flex')
    registrationForm.css('display', 'none')
  } else {
    registrationForm.attr('action', $(this).attr('data-registration-link'))
    registrationForm.css('display', 'block')
    registrationBtn.css('display', 'none')
    $('.js-training-center-id').attr('value', $(this).attr('data-id'))
  }
})

